import React, { useState, useEffect } from 'react';
import { loginAdmin } from '../api/authApi';

const AdminLogin = ({ onLoginSuccess }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Focus the input field on mount
    const input = document.getElementById('password-input');
    if (input) input.focus();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await loginAdmin(password);
      if (data.token) {
        localStorage.setItem('adminToken', data.token);
        onLoginSuccess();
      }
    } catch (err) {
      setError('Credenciales inválidas');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto p-8 glass-card rounded-2xl shadow-2xl border-slate-800/80 animate-fade-in-up mt-12">
      <h2 className="text-3xl font-extrabold mb-2 text-center bg-clip-text text-transparent bg-gradient-to-r from-cyan-400 to-indigo-500">
        Acceso Administrativo
      </h2>
      <p className="text-slate-400 text-center text-sm mb-8">
        Ingrese sus credenciales para acceder al panel.
      </p>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-slate-300 text-sm font-semibold mb-2" htmlFor="password-input">
            Contraseña
          </label>
          <input
            type="password"
            id="password-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-3 bg-slate-950/70 border border-slate-800 rounded-xl text-slate-100 placeholder-slate-600 focus:outline-none focus:border-cyan-500/50 focus:ring-1 focus:ring-cyan-500/25 transition-all duration-200"
            placeholder="••••••••"
            required
          />
        </div>
        {error && (
          <div className="p-3 bg-rose-500/10 text-rose-400 text-sm text-center rounded-xl border border-rose-500/25 font-medium animate-pulse">
            {error}
          </div>
        )}
        <button
          type="submit"
          disabled={loading}
          className="w-full py-3.5 bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-400 hover:to-blue-500 text-white font-semibold rounded-xl shadow-lg shadow-cyan-500/20 hover:shadow-cyan-500/30 transition-all duration-200"
        >
          {loading ? "Validando..." : "Acceder"}
        </button>
      </form>
    </div>
  );
};

export default AdminLogin;